<template>
    <div class="popupover3 gtyTip" id="gtyTip" :class="{ active: isShow}">
        <div class="popupover3-bg" @click="onGoBack()"></div>
        <div class="gtyTip-m">
            <div class="gtyTip-close js-popupClose2" @click="onGoBack()"><img src="https://resource.rcclchina.com.cn/cruiseDetail/closed.png" /></div>
            <p class="gtyTip-title">如预订航司分配房，请注意：</p>
            <p>该房型预订时无法确认具体房型、房间位置及房间号，且不支持自主选择。船司将根据航线实际库存情况进行房间分配，客人提交预订即视为接受船司分配结果。实际房型名称及房间号将在开航前更新显示于订单详情中，请及时关注相关更新信息，并打印最新版在线值船行程单。如客人对上述房型安排有顾虑，建议选择其他可确认房型以提升入住体验。</p>
            <p>特别提示：该房型最终分配的阳台房或套房可能有遮挡。</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "GtyPopup",
    props: {
        isShow: {
            type: Boolean
        },
        onGoBack: {
            type: Function
        }
    }
}
</script>

<style lang="less" scoped>
.popupover3 {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 10200;
    display: none;
    width: 100%;
    height: 100%;
    .popupover3-bg {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
    }
    .gtyTip-m {
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate3d(-50%, -50%, 0);
        -moz-transform: translate3d(-50%, -50%, 0);
        transform: translate3d(-50%, -50%, 0);
        width: 93%;
        padding: 20px;
        background: #fff;
        .gtyTip-close {
            position: absolute;
            top: 0;
            right: 0;
            width: 33px;
            height: 33px;
            padding: 5px;
            img {
                width: 100%;
            }
        }

        p {
            margin-top: 6px;
            margin-bottom: 0;
            color: #000;
            font-size: 13px;
        }

        .gtyTip-title {
            font-weight: bold;
        }
    }
}

.popupover3.active {
    display: block;
}
</style>